import React, { FC } from 'react';
import logo from '../onexthlogo.png';
import { Grid } from 'semantic-ui-react';

const Home:FC = () => {
  return(
    <Grid columns='equal'>
      <Grid.Column width={1}>
        <div className="outer">
          <div className="inner rotate">HOME</div>
        </div>
      </Grid.Column>
      <Grid.Column>
        <div className="App-header">
          <img src={logo} alt="logo" />
          <p>
            Welcome to OneXth.
          </p>
        </div>
      </Grid.Column>
      <Grid.Column width={1} />
    </Grid>
  )
}

export { Home };
